// extracted by mini-css-extract-plugin
module.exports = {"timelineItemTag":"_2G9xy6FZvvPKBic5vKjr0t"};